import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import Icon from '../components/ui/Icon';
import DotTrail from '../components/ui/DotTrail';
import site from '../data/site';

export function NotFound() {
  return (
    <section className="relative flex min-h-[70vh] items-center bg-canvas pt-32">
      <div
        className="pointer-events-none absolute -right-40 -top-24 h-[30rem] w-[30rem] rounded-full opacity-30 blur-3xl"
        style={{ background: 'radial-gradient(circle, #ffdb85 0%, #fbf9f5 70%)' }}
        aria-hidden="true"
      />
      <div className="shell relative max-w-xl py-20">
        <DotTrail count={5} />
        <p className="eyebrow mt-5">Page not found</p>
        <h1 className="mt-4 font-display text-[2.6rem] leading-[1.05] text-ink-950 sm:text-5xl">
          That page isn’t here
        </h1>
        <p className="mt-5 text-[1rem] leading-relaxed text-ink-700/85">
          The link may be out of date. Everything we hold is on the main page — or call the
          showroom and we will point you to it.
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <Button as={Link} to="/" variant="solid" size="md">
            Back to the showroom
            <Icon name="arrowRight" size={16} />
          </Button>
          <Button href={site.contact.phoneHref} variant="outline" size="md">
            <Icon name="phone" size={15} />
            {site.contact.phoneDisplay}
          </Button>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
